import React from "react";
import classNames from "classnames";
import { Label } from "lib/components/vendor";

export default function BalanceStatusLabel({ className, status, onlyIcon }) {
  return (
    status && (
      <span className={`BalanceStatusLabel BalanceStatusLabel--${status} u-whiteSpaceNowrap ${className || ""}`}>
        <Label empty circular /> {!onlyIcon && I18n.humanAttributeName("order", status)}
      </span>
    )
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/BalanceStatusLabel.jsx